import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isWebpSupported: null
};

export const webpSupportSlice = createSlice({
    name: 'webpSupport',
    initialState: initialState,
    reducers: {
        setIsWebpSupported(state, action) {
            state.isWebpSupported = action.payload;
        }
    },
});

export const getIsWebpSupported = state => state.webpSupport.isWebpSupported;


export const {
    setIsWebpSupported
} = webpSupportSlice.actions;

export default webpSupportSlice.reducer;

